const ontologyPrefix = import.meta.env.VITE_FOUNDRY_ONTOLOGY_PREFIX;

if (!ontologyPrefix) {
  throw new Error("Missing environment variable: VITE_FOUNDRY_ONTOLOGY_PREFIX");
}

export function foundryObjectType(objectType: string): string {
  return `${ontologyPrefix}.${objectType}`;
}
